import {Observable} from 'rxjs';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';
import {Filter, SimpleSeries, SimpleUnit, ThresholdStep} from '@core/interfaces/system/system-common';
import {LatestModelStatus} from '@core/interfaces/live/live';

export interface HydrogenUnits {
    hydrogenUnit: SimpleUnit;
}

export interface HydrogenGasTrendingDashboardData {
    data: SimpleSeries<Date, number>;
    thresholds: ThresholdStep[];
}

export abstract class HydrogenTrendingService {
    abstract getHydrogenGasTrendingDatasource(id: string, filter: Filter[]): Observable<DataSource>;

    abstract getCountResults(id: string, uploadTime?: string): Observable<number>;

    abstract getHydrogenGasTrendingLatestModelStatus(id: string, uploadTime?: string): Observable<LatestModelStatus>;

    abstract getHydrogenGasTrendingDashboardData(
        chart: string,
        id: string,
        uploadTime?: string,
    ): Observable<HydrogenGasTrendingDashboardData>;
}
